export default __webpack_public_path__ + "static/media/loader.0d10def8.svg";